import React from 'react';
import { Header, Icon, Container, Divider } from 'semantic-ui-react';
import SearchDivider from './SearchDivider.js';
import ActionCard from './ActionCard.js';

class SearchRsltArea extends React.Component {

  renderActionsArr = (arr) => {
    const actionsArray = [];

    arr.forEach(acy => {

      const action = this.props.actions[acy];
      const channel = (action) ? this.props.channels[action.chanId] : '';

      if (channel) //this checks that there is a channel in case action is published but channel isn't
        actionsArray.push(
          <li key={acy}>
            <ActionCard howToButton action={this.props.actions[acy]} channel={channel}/>
          </li>
        );
      }
    );
    return actionsArray;
  };

  renderRegChanDivider = (arr) => {
    const channelToRender = (this.props.query)
      ? this.props.queryResult.channels
      : this.props.channels;
    const channelToRenderArr = this.arrayMaker(channelToRender);
    const srchRsltContentChannels = [];

    channelToRenderArr.forEach((elem, index) => {
      const validAction = Boolean(this.props.actions[elem.actionId]);

      if(validAction)
      srchRsltContentChannels.push(
        <div key={index}>
          <Divider hidden />
          <SearchDivider channel={elem}/>
          <ul>
            {this.renderActionsArr(elem.actionId)}
          </ul>
        </div>
      )
    })
    return srchRsltContentChannels;
  };

  renderNoChanDivider = (arr) => {
    if (arr.length === 0)
      return;
    const nonChanDividerObj = {
      color: '#000',
      logo: 'lightbulb',
      name: 'Items matching your query'
    }
    return (
      <div>
        <SearchDivider channel={nonChanDividerObj}/>
        <ul>
          {this.renderActionsArr(arr)}
        </ul>
      </div>
    )
  };

  renderNoMatches = () => {
    return (
      <Container textAlign='center'>
        <Divider hidden/>
        <Header as='h2' icon>
          <Icon name='binoculars' circular color='grey' />
          We are sorry...
          <Header.Subheader>
            None of our records are matching your search.
            <br/> ¯\_(ツ)_/¯ <a href=''>Make a suggestion.</a>
          </Header.Subheader>
        </Header>
      </Container>
    )
  };

  getOrphanActions = () => {
    const channelToRender = this.props.queryResult.channels;
    const actionsToRender = this.props.queryResult.actions;

    const orphanActions = Object.keys(actionsToRender).filter(elem => {
      return (
        !Object.keys(channelToRender).includes(actionsToRender[elem].chanId)
      );
    });
    return orphanActions;
  };

  arrayMaker = (obj) => {
    let tempStoreArr = [];
    for (var prop in obj) {
      if(Object.prototype.hasOwnProperty.call(obj, prop))
      tempStoreArr.push(obj[prop]);
    }
    return tempStoreArr;
  };

  render() {
    const noMatches = (this.props.query
        && this.props.queryResult
        && Object.keys(this.props.queryResult.actions).length === 0
        && Object.keys(this.props.queryResult.channels).length === 0
      );

    return (
      <div>
        {this.renderRegChanDivider()}
        { (this.props.query) ? this.renderNoChanDivider(this.getOrphanActions()) : ''}
        { (noMatches) ? this.renderNoMatches() : '' }
      </div>
    );
  }

};

export default SearchRsltArea;



// WEBPACK FOOTER //
// ./src/components/SearchRsltArea.js